import { vidMap } from './rep-abon-data-grouping';
import './rep-abon-report-detail.css';
import { serverFetch } from "../../../server";
import { Table, Button, Typography, Collapse, message, Spin } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { strDate2Server } from "../../../extensions/utils";
import { useExcelData } from "../rep-excel-data-provider";

  const { Title } = Typography;
  const { Panel } = Collapse;
// Фильтрация по типу итогов: приход и возврат
function getTotal(items, detailType) {
	if (detailType === 'paid' || detailType === 'sale') {
		return items.reduce((sum, item) => sum + (item.discountedPrice || 0), 0);
	}

	if (detailType === 'salary') {
		return items.reduce((sum, item) => {
			const accrual = item.accrual || item.symaPut || 0;
			const deduction = item.deduction || item.symaExp || 0;
			return sum + (accrual - deduction);
		}, 0);
	}

	if (detailType === 'total') {
		return items.reduce((sum, item) => {
      const put = item.symaPut || 0;
      const exp = item.symaExp || 0;
      return sum + (put - exp);
    }, 0);
  }

  const key = detailType === 'exp' ? 'symaExp' : 'symaPut';
  return items.reduce((sum, item) => {
    const value = item[key];
    return value && value !== 0 ? sum + value : sum;
  }, 0);
}

function getPaidTotals(items) {
	return items.reduce(
		(acc, item) => {
			const pays = Array.isArray(item.itemsPay) ? item.itemsPay : [];
			acc.paid += pays.reduce((sum, p) => sum + (p.paid || 0), 0);
			acc.full += item.fullPrice || 0;
			acc.discount += item.discount || 0;
			acc.discountedPrice += item.discountedPrice || 0;
			acc.debt += item.debt || 0;
			if (item.isNew) acc.newCount += 1;
			if (item.isRenewal) acc.renewCount += 1;
			return acc;
		},
		{ paid: 0, full: 0, discount: 0, discountedPrice: 0, debt: 0, newCount: 0, renewCount: 0 }
	);
}

function getSaleTotals(items) {
	return getPaidTotals(items);
}

function getSalaryTotals(items) {
	return items.reduce(
		(acc, item) => {
			acc.discountedPrice += item.discountedPrice || 0;
			acc.salaryAmount += item.salaryAmount || 0;
			return acc;
		},
		{ discountedPrice: 0, salaryAmount: 0, total: 0 }
	);
}

// Таблица детализации по ячейке из общей таблицы
function DetailTable({ items, detailType, detailParams }) {
  const { setExcelData } = useExcelData();

  const columns = useMemo (() => {
    if (detailType === 'paid') {
      return [
        { title: 'Дата', dataIndex: 'saleDate', key: 'saleDate', render: (v) => v ? new Date(v).toLocaleDateString('ru-RU') : '' },
        { title: 'ФИО клиента', dataIndex: 'clientName', key: 'clientName' },
        { title: 'Абонемент', dataIndex: 'productName', key: 'productName' },
        { title: 'Цена со скидкой', dataIndex: 'discountedPrice', key: 'discountedPrice', align: 'right', render: (v) => (v || 0).toLocaleString() },
        { title: 'Оплата', dataIndex: 'itemsPay', align: 'right', key: 'itemsPay',
        render: (itemsPay) => {
          if (!Array.isArray(itemsPay)) return '';
          return (
            <div>
              {itemsPay.map((p, idx) => (
                <div key={idx}>
                  {p.paid.toLocaleString()}
                </div>
              ))}
            </div>
          );
        }},
        { title: 'Долг', dataIndex: 'debt', key: 'debt', align: 'right', render: (v) => (v || 0).toLocaleString() },
        { title: 'Вид оплаты', dataIndex: 'itemsPay', key: 'paymentType', align: 'center',   render: (itemsPay) => {
          if (!Array.isArray(itemsPay)) return '';
            return (
              <div>
                {itemsPay.map((p, idx) => (
                  <div key={idx}>
                    {p.paymentType || 'Не указан'}
                  </div>
                ))}
              </div>
            );
          },
        },
      ];
    }

    if (detailType === 'sale') {
      return [
        { title: 'Дата', dataIndex: 'saleDate', key: 'saleDate', render: (v) => v ? new Date(v).toLocaleDateString('ru-RU') : '' },
        { title: 'ФИО клиента', dataIndex: 'clientName', key: 'clientName', render: (n) => n || 'Не указан' },
        { title: 'Абонемент', dataIndex: 'productName', key: 'productName' },
        { title: 'Цена', dataIndex: 'fullPrice', key: 'fullPrice', align: 'right', render: (v) => (v || 0).toLocaleString() },
        { title: 'Скидка', dataIndex: 'discount', key: 'discount', align: 'right', render: (v) => (v || 0).toLocaleString() },
        { title: 'Цена со скидкой', dataIndex: 'discountedPrice', key: 'discountedPrice', align: 'right', render: (v) => (v || 0).toLocaleString() },
        { title: 'Новый', dataIndex: 'isNew', key: 'isNew', align: 'center', render: (v) => v ? '✓' : '' },
        { title: 'Прод-е', dataIndex: 'isRenewal', key: 'isRenewal', align: 'center', render: (v) => v ? '✓' : '' },
      ];
    }

    if (detailType === 'salary') {
      return [
        { title: 'Дата', dataIndex: 'saleDate', key: 'saleDate', render: (v) => v ? new Date(v).toLocaleDateString('ru-RU') : '' },
        { title: 'ФИО клиента', dataIndex: 'clientName', key: 'clientName', render: (n) => n || 'Не указан' },
        { title: 'Абонемент', dataIndex: 'productName', key: 'productName',},
        { title: 'Цена со скидкой', dataIndex: 'discountedPrice', key: 'discountedPrice', align: 'right', render: (v) => (v || 0).toLocaleString(),},
        { title: 'Процент', dataIndex: 'percentage', key: 'percentage', align: 'right', render: (v) => (v || 0).toLocaleString() },
        { title: 'Зарплата', dataIndex: 'salaryAmount', key: 'salaryAmount', align: 'right', render: (v) => (v || 0).toLocaleString() },
      ];
    }

    // Общие колонки (exp / total)
    return [
      { title: 'Тип покупки', dataIndex: 'vid', key: 'vid', render: (vid) => vidMap[vid] || vid },
      { title: 'Клиент', dataIndex: 'clientName', key: 'clientName' },
      { title: 'Название', dataIndex: 'tovName', key: 'tovName' },
      {
        title: detailType === 'exp' ? 'Возврат' : 'Сумма',
        key: 'sum',
        align: 'right',
        render: (_, row) => {
          if (detailType === 'total') {
            const diff = (row.symaPut || 0) - (row.symaExp || 0);
            return diff ? diff.toLocaleString() : '';
          }
          const val = row[detailType === 'exp' ? 'symaExp' : 'symaPut'];
          return val ? val.toLocaleString() : '';
        },
      },
    ];
  }, [detailType]);

  const totals = useMemo(() => {
  if (detailType === 'paid') return getPaidTotals(items);
  if (detailType === 'sale') return getSaleTotals(items);
  return getSalaryTotals(items);
}, [items, detailType]);

  const { selectedRowName = "Всего", vidName } = detailParams || {};
  useEffect(() => {
    if (!items?.length) return;

    const typeLabel = detailType === "sale" ? "Продажи" : detailType === "paid" ? "Оплаты" : "Зарплата";
    
    setExcelData({
      title: `${vidName} - ${typeLabel}`,
      columns,
      data: items,
      summary: [
        ['', '', 'ИТОГО:', totals.discountedPrice, totals.paid, totals.debt, '']
      ]
    });

    return () => setExcelData(null);
  }, [items, detailType, columns, setExcelData, selectedRowName, vidName, totals]);

  return (
    <Table
      columns={columns}
      dataSource={items}
      pagination={false}
      size="small"
      bordered
      rowKey={(row, idx) => idx}
      summary={() => {
        if (detailType === 'paid') {
          return (
            <Table.Summary.Row className="group-total-row">
              <Table.Summary.Cell index={0} colSpan={3} className="summary-cell-right">ИТОГО:</Table.Summary.Cell>
              <Table.Summary.Cell index={3} align="right">{totals.discountedPrice ? totals.discountedPrice.toLocaleString() : '0'}</Table.Summary.Cell>
              <Table.Summary.Cell index={4} align="right">{totals.paid ? totals.paid.toLocaleString() : '0'}</Table.Summary.Cell>
              <Table.Summary.Cell index={5} align="right">{totals.debt ? totals.debt.toLocaleString() : '0'}</Table.Summary.Cell>
            </Table.Summary.Row>
          );
        }
        if (detailType === 'sale') {
          return (
            <Table.Summary.Row className="group-total-row">
              <Table.Summary.Cell index={0} colSpan={3} className="summary-cell-right">ИТОГО:</Table.Summary.Cell>
              <Table.Summary.Cell index={3} align="right">{totals.full ? totals.full.toLocaleString() : ''}</Table.Summary.Cell>
              <Table.Summary.Cell index={4} align="right">{totals.discount ? totals.discount.toLocaleString() : '0'}</Table.Summary.Cell>
              <Table.Summary.Cell index={5} align="right">{totals.discountedPrice ? totals.discountedPrice.toLocaleString() : '0'}</Table.Summary.Cell>
              <Table.Summary.Cell index={6} align="center">{totals.newCount || '0'}</Table.Summary.Cell>
              <Table.Summary.Cell index={7} align="center">{totals.renewCount || '0'}</Table.Summary.Cell>
            </Table.Summary.Row>
          );
        }
        if (detailType === 'salary') {
          return (
            <Table.Summary.Row className="group-total-row">
              <Table.Summary.Cell index={0} colSpan={3} className="summary-cell-right">ИТОГО ПО ЗП:</Table.Summary.Cell>
              <Table.Summary.Cell index={3} align="right">{totals.discountedPrice ? totals.discountedPrice.toLocaleString() : '0'}</Table.Summary.Cell>
              <Table.Summary.Cell index={4} align="right"></Table.Summary.Cell>
              <Table.Summary.Cell index={5} align="right">{totals.salaryAmount ? totals.salaryAmount.toLocaleString() : '0'}</Table.Summary.Cell>
            </Table.Summary.Row>
          );
        }
      }
    }
      className="detail-table-no-margin"
    />
  );
}

// Детализация по ячейке: шапка, таблица, итоги
function RepAbonReportDetail({ detailData, onClose, detailParams, expandedGroups, setExpandedGroups }) {
  const { type: detailType, vidName, selectedRowName = 'Всего', userId } = detailParams || {};
  const [loading, setLoading] = useState(false);
  const [remoteData, setRemoteData] = useState(null);

  const getDetails = () => {
    if (!detailType) return;
    setLoading(true);

    const requestParams = {
      userId: userId ? userId : 0,
      employeeType: detailParams.employeeType,
      startDate: strDate2Server(detailParams.startDate),
      endDate: strDate2Server(detailParams.endDate),
      periodType: detailParams.periodType,
      reportType: detailType === 'sale' ? 2 : (detailType === 'paid' ? 1 : 0),
      saleType: vidName === 'Пакеты' ? 3 : (vidName === 'Абонементы' ? 2 : [2, 3]),
      specificProductIds: (detailParams?.productIds ?? detailParams?.productIds ?? [])
    };

    serverFetch("report/saleAbonDetails", {method: "GET", queryParams: requestParams})
      .then(data => {
        setRemoteData(Array.isArray(data) ? data : (data?.items || []));
        setLoading(false);
      })
      .catch(e => {
        message.error(e.userMessage);
        setLoading(false);
      });
  };


  useEffect(() => {
    getDetails();
  }, [userId, detailType, vidName])

  const dataToRender = remoteData ?? detailData;

  // if (!dataToRender) return null;

  const isGrouped = Array.isArray(dataToRender) && dataToRender[0]?.items;

  if (isGrouped) {

    const validGroups = dataToRender.filter(group => {
      const items = group.items || [group];
      if (detailType === 'paid') {
        return items && items.length > 0 && items.some(i => (i.discountedPrice || i.fullPrice || 0) !== 0);
      }
      if (detailType === 'sale') {
        return items && items.length > 0 && items.some(i => (i.discountedPrice || i.fullPrice || 0) !== 0);
      }
      if (detailType === 'salary') {
        return items && items.length > 0 && items.some(i => ((i.accrual || i.symaPut || 0) !== 0) || ((i.deduction || i.symaExp || 0) !== 0));
      }
      return items.some(item => {
        if (detailType === 'exp') {
          return item.symaExp && item.symaExp !== 0;
        } else {
          return item.symaPut && item.symaPut !== 0;
        }
      });
    });

    if (validGroups.length === 0) {
      return (
        <div className="report-detail">
          <div className="detail-header">
            <Title level={4} className="detail-title detail-title-500">
              Подробно: {selectedRowName} - {vidName} - {detailType === 'sale' ? 'Продажи' : (detailType === 'paid' ? 'Оплаты' : 'Зарплата') }
            </Title>
            <Button onClick={onClose} shape="circle" size="small" className="close-button">×</Button>
          </div>
        </div>
      );
    }

    return (
    <div>
      {loading ? (
        <div className="report-loading">
          <Spin size="large" />
        </div>
      ) : dataToRender ? (
      <>
        <div className="abon-detail report-detail">
          <div className="detail-header">
            <Title level={4} className="detail-title detail-title-bold">
              Подробно: {selectedRowName} - {vidName} - {detailType === 'sale' ? 'Продажи' : (detailType === 'paid' ? 'Оплаты' : 'Зарплата') }
            </Title>
            <Button onClick={onClose} shape="circle" size="small" className="close-button">×</Button>
          </div>
          <div className="detail-content">
            <Collapse
              bordered={false}
              activeKey={Array.from(expandedGroups)}
              onChange={keys => setExpandedGroups(new Set(Array.isArray(keys) ? keys : [keys]))}
              expandIconPosition="start"
              className="collapse-detail"
            >
              {validGroups.map(group => {
                const items = group.items || [group];
                const groupTotal = getTotal(items, detailType);
                const expandKey = String(group.displayName || group.kassaName || group.periodName);
                return (
                  <Panel
                    key={expandKey}
                    header={
                      <div className="panel-header panel-header-group">
                        <span className="type-label">{group.displayName || group.kassaName || group.periodName}</span>
                        <span className="type-count">({items.length})</span>
                        <span className="detail-group-total detail-group-total-main">{groupTotal ? groupTotal.toLocaleString() : ''}</span>
                      </div>
                    }
                    showArrow
                  >
                    <DetailTable items={items} detailType={detailType} detailParams={detailParams} />
                  </Panel>
                );
              })}
            </Collapse>
          </div>
        </div>
      </>
    ) : null}
    </div>
    );
  } else {
    return (
      <div>
      {loading ? (
        <div className="report-loading">
          <Spin size="large" />
        </div>
      ) : dataToRender ? (
      <>
      <div className="abon-detail report-detail">
        <div className="detail-header">
          <Title level={4} className="detail-title">
            Подробно: {selectedRowName} - {vidName} - {detailType === 'sale' ? 'Продажи' : (detailType === 'paid' ? 'Оплаты' : 'Зарплата') }
          </Title>
          <Button onClick={onClose} shape="circle" size="small" className="close-button">×</Button>
        </div>
        <div className="detail-content">
        <DetailTable items={dataToRender} detailType={detailType} detailParams={detailParams} />
        </div>
      </div>
      </>
    ) : null}
    </div>
    );
}
}

export default RepAbonReportDetail; 